import Simplemodal from '../../plugins/simplemodal.js';

// const simplemodal = new Simplemodal()
// window.simplemodal = simplemodal

// const simplepopover = new Simplemodal({
//   trigger : "data-popover-trigger",
//   clickOutSideClose : true,
//   backFixed : false
// })

// const fullScreenMenu = new Simplemodal({
//   trigger : "data-fullScreenMenu-trigger",
//   clickOutSideClose : true
// })

// const sideFixedMenuButtons = new Simplemodal({
//   trigger : "data-sideFixedMenuButtons-trigger",
//   clickOutSideClose : true,
//   backFixed : false
// })

const simplemodal = new Simplemodal();
window.simplemodal = simplemodal;

const simplepopover = new Simplemodal({
  trigger: "data-popover-trigger",
  clickOutSideClose: true,
  backFixed: false,
});
window.simplepopover = simplepopover;

const fullScreenMenu = new Simplemodal({
  trigger: "data-fullScreenMenu-trigger",
  clickOutSideClose: true,
});

const sideFixedMenuButtons = new Simplemodal({
  trigger: "data-sideFixedMenuButtons-trigger",
  clickOutSideClose: true,
  backFixed: false,
});

const simplemodalmulti = new Simplemodal({
  trigger: "data-modalmulti-trigger",
  clickOutSideClose: true,
  backFixed: false,
  multipleOpen: true,
});
window.simplemodalmulti = simplemodalmulti;
